// =============================================================================
// Home's "N pallets need a billing code" figure, read off get_inventory_pulse.
//
// The server gives the figure ONLY to a seat that keeps Unbilled pallets
// (can_fix_pallet_billing(), the SQL twin of useCanFixPalletBilling; mig
// 20261066000000, F09-NARROW, ruled by Jason 5 Oct). Every other seat gets
// `unbilledPallets: null`: the billing-code lookup answers it with no codes,
// and counted against no codes every live pallet would read as unbilled.
//
// So null is "not yours to see", never "none": it must not be coerced to 0
// (the pulse's other fields are `Number(x ?? 0)`, which here would state a
// confident zero) and it must never raise the alert.
// =============================================================================

/** The unbilled count the server gave, or null when it withheld it (or the
 *  field is missing / not a number). Never 0 for a withheld figure. */
export function unbilledPalletsOf(pulse: Record<string, unknown>): number | null {
  const v = pulse.unbilledPallets
  if (v == null) return null
  const n = Number(v)
  return Number.isFinite(n) ? n : null
}

/** Does Home show the amber alert? Only for a figure the server gave, above
 *  zero, to a seat that may open the page (`useCanFixPalletBilling() === true`). */
export function showsUnbilledAlert(
  unbilled: number | null,
  canFixBilling: boolean,
): unbilled is number {
  return canFixBilling && unbilled != null && unbilled > 0
}
